<table class="table table-bordered table-striped table-hover" id="excel-table">
    <thead class="thead-dark">
        <tr>
            <th translate class="header-float row-float-total row-table-head">
                {{'rmpv.analiseVenda.titulo'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.jan'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.fev'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.mar'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.abr'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.mai'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.jun'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.jul'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.ago'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.set'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.out'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.nov'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseVenda.meses.dez'}}
            </th>
            <th translate class="text-right header-float">
                Total
            </th>
            <th translate class="text-right header-float">
                % Total
            </th>
            <th translate class="text-right header-float">
                Total {{anoFiltro - 1}}
            </th>
            <th translate class="text-right header-float">
                Total {{anoFiltro - 2}}
            </th>
        </tr>
    </thead>
    <tbody>
        <!-- PRVISAO VENDA -->
        <tr *ngFor="let categoria of dados.previsao_venda.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class= "row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency: ' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency: ' '}}</td>
        </tr>
        <tr>
            <td translate class="dark-row row-float-total">{{'rmpv.analiseVenda.totalPrevisaoVendasMOPCA'}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_01 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_02 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_03 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_04 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_05 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_06 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_07 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_08 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_09 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_10 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_11 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.mes_12 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.total_ano | currency: ' '}}</td>
            <td class="text-right dark-row percentual">{{dados.previsao_venda.total.percentual | percent: '1.1'}}
            </td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.total_ano_anterior | currency: ' '}}
            </td>
            <td class="text-right dark-row">{{dados.previsao_venda.total.total_ano_retrasado | currency: ' '}}
            </td>
        </tr>
        <!-- VENDA-MO -->
        <tr *ngFor="let categoria of dados.venda_mo.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency: ' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency: ' '}}</td>
        </tr>
        <tr>
            <td translate class="dark-row row-float-total">{{'rmpv.analiseVenda.totalVendasMO'}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_01 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_02 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_03 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_04 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_05 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_06 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_07 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_08 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_09 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_10 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_11 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.mes_12 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.total_ano | currency: ' '}}</td>
            <td class="text-right dark-row percentual">{{dados.venda_mo.total.percentual | percent: '1.1'}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_mo.total.total_ano_retrasado | currency: ' '}}</td>
        </tr>
        <!-- %REALIZADO MO / PREVISÃO MO -->
        <!-- <tr>
            <td [translate]="getTranslate(dados.realizado_previsao_mo.descricao)" class="row-float"></td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_01 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_02 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_03 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_04 | percent: '1.1'}}</td>         
            <td class="text-right">{{dados.realizado_previsao_mo.mes_05 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_06 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_07 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_08 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_09 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_10 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_11 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.mes_12 | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.total_ano | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_previsao_mo.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.total_ano_anterior | percent: '1.1'}}</td>
            <td class="text-right">{{dados.realizado_previsao_mo.total_ano_retrasado | percent: '1.1'}}</td>
        </tr> -->
        <!-- VENDA PEÇA -->
        <tr *ngFor="let categoria of dados.venda_peca.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency: ' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency: ' '}}</td>
        </tr>
        <tr>
            <td translate class="dark-row row-float-total">{{'rmpv.analiseVenda.totalVendasPeça'}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_01 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_02 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_03 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_04 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_05 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_06 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_07 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_08 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_09 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_10 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_11 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.mes_12 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.total_ano | currency: ' '}}</td>
            <td class="text-right dark-row percentual">{{dados.venda_peca.total.percentual | percent: '1.1'}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_peca.total.total_ano_retrasado | currency: ' '}}</td>
        </tr>
        <!-- VENDA ACESSÓRIO -->
        <tr *ngFor="let categoria of dados.venda_acessorio.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency: ' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency: ' '}}</td>
        </tr>
        <tr>
            <td translate class="dark-row row-float-total">{{'rmpv.analiseVenda.totalVendasAcessorio'}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_01 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_02 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_03 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_04 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_05 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_06 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_07 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_08 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_09 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_10 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_11 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.mes_12 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.total_ano | currency: ' '}}</td>
            <td class="text-right dark-row percentual">{{dados.venda_acessorio.total.percentual | percent: '1.1'}}
            </td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.total_ano_anterior | currency: ' '}}
            </td>
            <td class="text-right dark-row">{{dados.venda_acessorio.total.total_ano_retrasado | currency: ' '}}
            </td>
        </tr>
        <tr *ngFor="let categoria of dados.venda_clothing.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency: ' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency: ' '}}</td>
        </tr>    
        <tr *ngFor="let categoria of dados.venda_outros.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency: ' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency: ' '}}</td>
        </tr>
        <tr *ngFor="let categoria of dados.venda_interna.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency: ' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency: ' '}}</td>
        </tr>
        
        <!-- TOTAL VENDAS PCA -->
        <tr>
            <td [translate]="getTranslate(dados.venda_pca.descricao)" class="dark-row row-float-total"></td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_01 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_02 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_03 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_04 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_05 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_06 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_07 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_08 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_09 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_10 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_11 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.mes_12 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total_ano | currency: ' '}}</td>
            <td class="text-right dark-row percentual">{{dados.venda_pca.percentual | percent: '1.1'}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total_ano_retrasado | currency: ' '}}</td>
        </tr>
        <!-- % REALIZADO VENDAS PCA / PREVISÃO  -->
        <tr>
            <td [translate]="getTranslate(dados.realizado_vendas_pca_previsao.descricao)" class="row-float"></td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_01 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_02 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_03 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_04 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_05 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_06 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_07 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_08 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_09 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_10 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_11 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.mes_12 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.total_ano | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.percentual | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.total_ano_anterior | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_vendas_pca_previsao.total_ano_retrasado | percent: '1.1'}}</td>
        </tr>
        <!-- TOTAL VENDAS MO + PCA  -->
        <tr>
            <td [translate]="getTranslate(dados.total_vendas_mopca.descricao)" class="dark-row row-float-total"></td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_01 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_02 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_03 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_04 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_05 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_06 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_07 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_08 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_09 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_10 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_11 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.mes_12 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.total_ano | currency: ' '}}</td>
            <td class="text-right dark-row percentual">{{dados.total_vendas_mopca.percentual | percent: '1.1'}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.total_vendas_mopca.total_ano_retrasado | currency: ' '}}</td>
        </tr>
        <!-- % REALIZADO MO + PCA / PREVISÃO MO + PCA  -->
        <tr>
            <td [translate]="getTranslate(dados.realizado_mopca_previsao_mopca.descricao)" class="row-float"></td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_01 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_02 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_03 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_04 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_05 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_06 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_07 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_08 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_09 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_10 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_11 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.mes_12 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.total_ano | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.percentual | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.total_ano_anterior | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.realizado_mopca_previsao_mopca.total_ano_retrasado | percent: '1.1'}}</td>
        </tr>
        <!-- RELAÇÂO PO / MO  -->
        <tr>
            <td [translate]="getTranslate(dados.relacao_pomo.descricao)" class="row-float"></td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_01 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_02 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_03 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_04 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_05 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_06 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_07 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_08 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_09 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_10 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_11 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.mes_12 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.total_ano | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.percentual | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.total_ano_anterior | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.relacao_pomo.total_ano_retrasado | percent: '1.1'}}</td>
        </tr>
        <!-- VENDAS PEÇAS OFICINA / TOTAL VENDAS PCA  -->
        <tr>
            <td [translate]="getTranslate(dados.percentual_venda_oficina_total_pca.descricao)" class="row-float"></td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_01 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_02 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_03 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_04 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_05 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_06 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_07 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_08 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_09 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_10 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_11 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.mes_12 | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.total_ano | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.percentual | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.total_ano_anterior | percent: '1.1'}}</td>
            <td class="text-right percentual">{{dados.percentual_venda_oficina_total_pca.total_ano_retrasado | percent: '1.1'}}</td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        
        <!-- VENDA CLOTHING E OUTROS -->
        <!-- <tr *ngFor="let categoria of dados.venda_clothing.linhas">
            <td class="row-float">{{categoria.descricao}}</td>
            <td class="text-right">{{categoria.mes_01 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency: ' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency: ' '}}</td>
        </tr> -->
        <!-- VENDA OUTROS -->
        <!-- <tr *ngFor="let categoria of dados.venda_outros.linhas">
            <td class="row-float">{{categoria.descricao}}</td>
            <td class="text-right">{{categoria.mes_01 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency: ' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency: ' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency: ' '}}</td>
        </tr> -->
        <!-- TOTAL VENDA PCA -->
        <!-- <tr>
            <td class="dark-row row-float-total">Total Vendas PCA</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_01 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_02 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_03 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_04 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_05 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_06 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_07 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_08 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_09 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_10 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_11 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.mes_12 | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.total_ano | currency: ' '}}</td>
            <td class="text-right dark-row percentual">{{dados.venda_pca.total.percentual | percent: '1.1'}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.total_ano_anterior | currency: ' '}}</td>
            <td class="text-right dark-row">{{dados.venda_pca.total.total_ano_retrasado | currency: ' '}}</td>
        </tr> -->
    </tbody>
</table>